import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import { FleetMessage } from '.';
import { memo } from 'react';

const ReadSentCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;

  const data = props.dataItem as FleetMessage;

  return (
      <td {...props.tdProps}>
          {data.ReadSentDateTime ? dayjs.utc(data.ReadSentDateTime).tz("America/New_York").format('MM/DD/YYYY HH:mm') : ''}
      </td>
  );
}

export default memo(ReadSentCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);
